import React, { useState, useEffect } from "react";
import Data from "../App";
import { map, distinctUntilChanged } from "rxjs/operators";
import CompJsonEdit from "./CompJsonEdit";

const SignalView = ({ signal }) => {
  let attr = "";
  if (signal.get("attributes")) {
    attr = signal.get("attributes").map((attr, index) => (
      <div key={index} className="SignalPayload">
        <span>{attr.get("name")}</span>
      </div>
    ));
  }
  return (
    <div className="SignalView">
      >
      <div className="SignalName">
        <span>{signal.get("name")}</span>
      </div>
      {attr}
    </div>
  );
};
export default SignalView;



// WEBPACK FOOTER //
// ./src/components/SignalView.js